$('form#new-ticket-form').on('submit', function(e){

    $.ajax({
        url: $(this).attr('action'),
        type: 'post',
        data: $(this).serialize(),
        dataType: 'json',
        success: function(data) {

            console.log(data);

            if (data.item !== undefined) {
                $('#tickets').prepend(data.item);
            }

            if (data.errors !== undefined) {
                $('#tickets').prepend(data.errors.message);
            }
        }
    });

    $(this)[0].reset();

    e.preventDefault();
});
